import React, { type ComponentProps } from 'react';

import { clsx } from 'clsx';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';

type Props = {
  isActive?: boolean;
  isCompact?: boolean;
} & ComponentProps<typeof ExtendedLink>;

export function NavigationLink({
  className,
  isActive = false,
  isCompact = false,
  ...rest
}: Props) {
  const conditionalStyles = {
    [styles['navigationLink--active']]: isActive,
    [styles['navigationLink--compact']]: isCompact,
  };

  return (
    <ExtendedLink
      className={clsx(styles.navigationLink, conditionalStyles, className)}
      {...rest}
    />
  );
}
